import { StatsManfreditesResponse } from './stats-manfredites.response';
export const createStatsManfreditesResponseMock = (customValues = {}) => {
    const response = new StatsManfreditesResponse();
    response.hasEnoughManfredites = customValues.hasEnoughManfredites ?? true;
    response.stats = customValues.stats ?? {
        manfreditesCount: 100,
        salariesHeatMap: {
            experienceLabels: ['<2', '2-5', '5-10', '>10'],
            salaryLabels: ['<20K', '21-30K', '31-40K', '41-50K', '51-60K', '61-80K', '81-100K', '101-120K', '121-150K', '151-180K', '>181K'],
            heatMap: [
                [5.4, 10.2, 3.1, 0.0],
                [6.2, 12.5, 4.3, 0.0],
                [4.1, 9.8, 5.7, 0.0],
                [3.2, 8.5, 6.2, 0.0],
                [2.9, 7.5, 7.0, 0.0],
                [2.5, 6.8, 7.8, 0.0],
                [1.9, 5.2, 8.5, 0.0],
                [1.1, 3.9, 7.0, 0.0],
                [0.8, 2.5, 5.5, 0.0],
                [0.3, 1.2, 4.1, 0.0],
                [0.1, 0.5, 2.3, 0.0]
            ]
        },
        remoteOptionsPercentages: { remote: 60, hybrid: 30, onSite: 10 },
        manfredites: [
            {
                roles: ['Frontend Developer'],
                mainTechs: ['React'],
                techs: ['React', 'Redux', 'TypeScript'],
                experienceRange: '2-5',
                salaryRange: '21-30K',
                wantsRemote: true,
                wantsHybrid: false,
                wantsFaceToFace: false,
                contractTypes: ['SELF_EMPLOYED'],
                lastUpdate: new Date('2023-01-12T12:00:00.000Z')
            }
        ]
    };
    return response;
};
//# sourceMappingURL=stats-manfredites.response.mock.js.map